import styled from 'styled-components';

export const OptionItemSpriteLargeListStyles = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 0 16px;
`;

export const OptionItemSpriteLargeStyles = styled.div<{
  isSelected: boolean;
  theme?: 'violet';
  disableGrayscale?: boolean;
}>`
  body.dark & {
    ${({ theme }) => {
      return `
        --bg-color: #FFFFFF1A;
        --bg-color-selected: #803EFF;
      `;
    }}
  }

  --bg-color: #ffffff1a;
  --bg-color-selected: #ece4fd;
  box-sizing: border-box;
  height: 86px;
  display: flex;
  align-items: center;
  cursor: pointer;
  padding: 20px;
  background-color: ${({ isSelected }) =>
    isSelected ? 'var(--bg-color-selected)' : 'var(--bg-color)'};
  border-radius: 16px;
  position: relative;
  overflow: hidden;
  user-select: none;

  ${({ isSelected, theme }) => {
    if (isSelected) {
      switch (theme) {
        case 'violet':
          return `
          .option-item-sprite-large-title {
            color: #171123;
          }
        `;
        default:
          return `
            &:before {
                content: '';
                position: absolute;
                top: 0;
                left: 0;
                width: 100%;
                height: 100%;
                background: transparent;
                box-sizing: border-box;
                border-radius: 16px;
                z-index: 2;
            }
        `;
      }
    }
  }}
`;

export const OptionItemSpriteLargeImageContainerStyles = styled.div<{
  isSelected: boolean;
  disableGrayscale?: boolean;
}>`
  width: 224px;
  aspect-ratio: 1.875;
  position: absolute;
  right: -12px;
  z-index: 2;
  font-size: 0;
  line-height: 0;

  img {
    width: 100%;
    height: 100%;
    filter: ${({ isSelected, disableGrayscale }) => {
      if (disableGrayscale) return 'none';
      return isSelected ? 'none' : 'grayscale(100%) brightness(0.6)';
    }};
    transition: filter 0.2s ease;
  }
`;
